import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import cctvHero from "../assets/Hero/cctv.jpg"; // Replace with your hero image
import cctvImage from "../assets/Hero/cctv2.jpg"; // Replace with your CCTV image
import featuresImage from "../assets/Hero/Nairobi.jpg"; // Replace with your features image
import "../assets/css/cctvPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const cctvData = {
  hero: {
    title: "CCTV Solutions",
    subtitle: "Enhancing Security with Advanced Surveillance Systems",
  },
  introduction: {
    heading: "Why CCTV Solutions Matter",
    paragraphs: [
      "CCTV systems are essential for ensuring the safety and security of your premises, providing real-time monitoring and recording capabilities.",
      "Our CCTV solutions are designed to offer high-quality surveillance, advanced analytics, and seamless integration with your security infrastructure.",
    ],
  },
  features: {
    heading: "Our CCTV Solutions Features",
    items: [
      "High-Resolution Cameras",
      "24/7 Real-Time Monitoring",
      "Motion Detection & Alerts",
      "Remote Access & Control",
      "Night Vision & Weatherproofing",
      "Expert Installation & Support",
    ],
  },
  benefits: {
    heading: "Benefits of Our Solutions",
    items: [
      {
        icon: "fa fa-video-camera",
        text: "Enhanced security with real-time monitoring.",
      },
      {
        icon: "fa fa-shield",
        text: "Deterrence of criminal activities.",
      },
      {
        icon: "fa fa-line-chart",
        text: "Scalable solutions for any size of premises.",
      },
      {
        icon: "fa fa-check-circle",
        text: "Compliance with industry standards and regulations.",
      },
      {
        icon: "fa fa-headphones",
        text: "Expert support for seamless operations.",
      },
    ],
  },
  cta: {
    heading: "Ready to Secure Your Premises?",
    text: "Contact us today to learn more about our CCTV Solutions and how we can help protect your business.",
  },
};

export const CCTVPage = ({ data }) => {
  const cctvRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = cctvRef.current.querySelectorAll(".cctv-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: cctvRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div id="cctv-page" ref={cctvRef}>
      {/* Hero Section */}
      <div
        className="cctv-hero-section"
        style={{ backgroundImage: `url(${cctvHero})` }}
      >
        <h1 className="cctv-animate">{cctvData.hero.title}</h1>
        <p className="cctv-animate">{cctvData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="container cctv-introduction">
        <div className="row">
          <div className="col-md-6">
            <h2 className="cctv-animate">{cctvData.introduction.heading}</h2>
            {cctvData.introduction.paragraphs.map((paragraph, index) => (
              <p key={index} className="cctv-animate">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-md-6 cctv-image-container">
            <img
              src={cctvImage}
              className="img-fluid cctv-animate"
              alt="CCTV Solutions"
            />
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="container cctv-features">
        <div className="row">
          <div className="col-md-6 cctv-image-container">
            <img
              src={cctvHero}
              className="img-fluid cctv-animate"
              alt="CCTV Features"
              style={{ maxWidth: "100%" }}
            />
          </div>
          <div className="col-md-6">
            <h2 className="cctv-animate">{cctvData.features.heading}</h2>
            <ul>
              {cctvData.features.items.map((item, index) => (
                <li key={index} className="cctv-animate">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <div
        className="container-fluid cctv-benefits"
        style={{ backgroundImage: `url(${featuresImage})` }}
      >
        <div className="overlay">
          <h2 className="cctv-animate">{cctvData.benefits.heading}</h2>
          <div className="benefits-cards">
            {cctvData.benefits.items.map((item, index) => (
              <div key={index} className="benefit-card cctv-animate">
                <i className={item.icon}></i>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      {/* <div className="container cctv-cta">
        <h2 className="cctv-animate">{cctvData.cta.heading}</h2>
        <p className="cctv-animate">{cctvData.cta.text}</p>
        <button
          className="btn btn-primary cctv-animate"
          onClick={handleContactClick} // Add onClick handler
        >
          Contact Us
        </button>
      </div> */}
    </div>
  );
};